import type { UseQueryOptions } from "@tanstack/react-query";
import { queryOptions, skipToken, useQuery } from "@tanstack/react-query";
import api from "../api";
import urls from "../urls";
import type { SuggestedMeteringOrMarketLocationResponse } from "../utils/backend-types";

export const suggestedMeteringOrMarketLocationQueries = {
  list: () => queryOptions({ queryKey: ["suggestedMeteringOrMarketLocation"] }),
  detail: (generatorId?: number) =>
    queryOptions<SuggestedMeteringOrMarketLocationResponse>({
      queryKey: ["suggestedMeteringOrMarketLocation", { generatorId }],
      queryFn: generatorId
        ? () => fetchsuggestedMeteringOrMarketLocation(generatorId)
        : skipToken
    })
};

export function useSuggestedMeteringOrMarketLocation(
  generatorId?: number,
  options?: Partial<UseQueryOptions<SuggestedMeteringOrMarketLocationResponse>>
) {
  const {
    data: suggestedMeteringOrMarketLocation,
    isLoading,
    error
  } = useQuery({
    ...suggestedMeteringOrMarketLocationQueries.detail(generatorId),
    ...options
  });

  return { suggestedMeteringOrMarketLocation, isLoading, error };
}

async function fetchsuggestedMeteringOrMarketLocation(generatorId: number) {
  const suggestedMeteringOrMarketLocationUrl =
    urls.api.suggestedMeteringOrMarketLocation(generatorId);
  const response = await api.get<SuggestedMeteringOrMarketLocationResponse>(
    suggestedMeteringOrMarketLocationUrl
  );
  return response.data;
}
